import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { SERVICE_ENDPOINT } from '../../constants';
import { CheckTokenRequest, LoginRequest } from '../../models/api/auth';
import { AccountInfoResponse } from '../../models/api/account';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpService {
  private _http = inject(HttpClient);

  login(request: LoginRequest) {
    return this._http.post<AccountInfoResponse>(
      SERVICE_ENDPOINT.login,
      request,
    );
  }

  checkToken(request: CheckTokenRequest) {
    return this._http.post<AccountInfoResponse>(
      SERVICE_ENDPOINT.checkToken,
      request,
    );
  }
}
